import React from "react";
import "./RfqStepper.css";

// Segmented progress bar: one segment per step, filled up to and including the current one.
export const RfqStepProgress = ({ current, total, sticky = false }) => {
  const safeTotal = Math.max(Number(total) || 1, 1);
  const safeCurrent = Math.min(Math.max(Number(current) || 1, 1), safeTotal);
  return (
    <ul
      className={`rfq-stepper-progress${
        sticky ? " rfq-stepper-progress--sticky bg-white" : ""
      }`}
      role="progressbar"
      aria-label={`Step ${safeCurrent} of ${safeTotal}`}
      aria-valuemin={1}
      aria-valuemax={safeTotal}
      aria-valuenow={safeCurrent}
    >
      {Array.from({ length: safeTotal }, (_, i) => (
        <li key={i} className={i < safeCurrent ? "bg-primary" : "bg-light"} />
      ))}
    </ul>
  );
};

// "SECTION 1 OF 5" + section title + description.
export const RfqStepHead = ({ current, total, title, description }) => (
  <div className="rfq-step-head bg-primary-dim">
    <span className="rfq-step-eyebrow text-primary">
      Section {Number(current) || 1} of {Math.max(Number(total) || 1, 1)}
    </span>
    <h5 className="rfq-step-title text-primary">{title}</h5>
    {description ? <p className="rfq-step-desc text-soft">{description}</p> : null}
  </div>
);
